import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qad',
  templateUrl: './qad.component.html',
  styleUrls: ['./qad.component.css']
})
export class QadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
